/* eslint-disable jsx-a11y/control-has-associated-label */
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import React, {
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  ColDef,
  ColGroupDef,
  IFilterOptionDef,
  RowSpanParams,
  ValueFormatterParams,
} from "ag-grid-community";
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import Worker from "worker-loader!./report.worker";
import { LicenseManager } from "@ag-grid-enterprise/core";

import { ReportSummary } from "./report.worker";
import "./Report.css";
import HeadlinesReport from "./HeadlinesReport";

LicenseManager.setLicenseKey(
  "CompanyName=Resource Software International Ltd,LicensedApplication=Shadow,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-032296,SupportServicesEnd=20_October_2023_[v2]_MTY5Nzc1NjQwMDAwMA==0c008d8dba7b9997038f1e1fee335d4a"
);
interface Model {
  [colId: string]: any;
}

function getter(value: number) {
  // hoping this fixes something
  return `${Math.floor(Math.floor(value / 1000) / 60)
    .toString()
    .padStart(2, "0")}:${(Math.floor(value / 1000) % 60)
      .toString()
      .padStart(2, "0")}`;
}

// const aggFuncs = {
//   mySum: (params: any) => {
//     let sum = 0;
//     params.values.forEach((value: any) => {
//       const minutes = parseInt((value || "")?.split(":")?.[0], 10);
//       const seconds = parseInt((value || "")?.split(":")?.[1], 10);
//       const durationSeconds = minutes * 60 + seconds;
//       sum += durationSeconds;
//     });
//     return `${Math.floor(Math.floor(sum / 60))
//       .toString()
//       .padStart(2, "0")}:${Math.floor(sum % 60)
//       .toString()
//       .padStart(2, "0")}`;
//   },
//   myAvg: (params: any) => {
//     let count = 0;
//     let sum = 0;
//     params.values.forEach((value: any) => {
//       const minutes = parseInt((value || "")?.split(":")?.[0], 10);
//       const seconds = parseInt((value || "")?.split(":")?.[1], 10);
//       const durationSeconds = minutes * 60 + seconds;
//       if (durationSeconds > 0) {
//         sum += durationSeconds;
//         count += 1;
//       }
//     });
//     if (count === 0) {
//       return "00:00";
//     }
//     return `${Math.floor(Math.floor(sum / count / 60))
//       .toString()
//       .padStart(2, "0")}:${Math.floor((sum / count) % 60)
//       .toString()
//       .padStart(2, "0")}`;
//   },
//   myMax: (params: any) => {
//     let max = 0;
//     params.values.forEach((value: any) => {
//       const minutes = parseInt((value || "")?.split(":")?.[0], 10);
//       const seconds = parseInt((value || "")?.split(":")?.[1], 10);
//       const durationSeconds = minutes * 60 + seconds;
//       if (durationSeconds > max) {
//         max = durationSeconds;
//       }
//     });
//     return `${Math.floor(Math.floor(max / 60))
//       .toString()
//       .padStart(2, "0")}:${Math.floor(max % 60)
//       .toString()
//       .padStart(2, "0")}`;
//   },
// };

const textFilterParams = {
  filterOptions: [
    {
      displayKey: "textGreaterThen",
      displayName: "Greater Than",
      test: (filterVal: any, cellVal: any) => {
        // minutes:seconds (00:00) format
        if (/^(\d{1,}:\d{2})$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(5, "0");
          return getter(cellVal) > formattedFilterValue;
        }
        // minutes:seconds (00:0) format
        if (/^(\d{1,}:\d{1})$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(5, "0").concat("0");
          return getter(cellVal) > formattedFilterValue;
        }
        // minutes: (00:) format
        if (/^(\d{1,}:)$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(2, "0").concat("00");
          return getter(cellVal) > formattedFilterValue;
        }
        // minutes format
        if (/^\d{1,}$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(2, "0").concat(":00");
          return getter(cellVal) > formattedFilterValue;
        }
        return false;
      },
    },
    {
      displayKey: "textLessThen",
      displayName: "Less Than",
      test: (filterVal: any, cellVal: any) => {
        // minutes:seconds (00:00) format
        if (/^(\d{1,}:\d{2})$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(5, "0");
          return cellVal < formattedFilterValue;
        }
        // minutes:seconds (00:0) format
        if (/^(\d{1,}:\d{1})$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(5, "0").concat("0");
          return cellVal < formattedFilterValue;
        }
        // minutes: (00:) format
        if (/^(\d{1,}:)$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(2, "0").concat("00");
          return cellVal < formattedFilterValue;
        }
        // minutes format
        if (/^\d{1,}$/.test(filterVal)) {
          const formattedFilterValue = filterVal.padStart(2, "0").concat(":00");
          return cellVal < formattedFilterValue;
        }
        return false;
      },
    },
    "equals",
    "contains",
    "notContains",
  ] as IFilterOptionDef[],
};

export default function Report({
  filterModel,
  organizationId,
  version,
  index,
  fontValue,
  mode,
  headlinesEnabled,
  hasCX,
  setSummaryFilterRef
}: {
  filterModel: Model | undefined;
  organizationId: string | undefined;
  version: number;
  index: string;
  fontValue: number;
  mode: string;
  headlinesEnabled: boolean;
  hasCX: boolean;
  setSummaryFilterRef: React.Dispatch<SetStateAction<{ [colId: string]: any }>>
}) {
  const workerRef = useRef<Worker>(new Worker());
  const gridRef = useRef<AgGridReact>(null);
  const [gridReady, setGridReady] = useState(false);
  const [rowData, setRowData] = useState<ReportSummary[]>([]);

  useEffect(() => {
    if (!gridReady) return;
    if (!gridRef || !gridRef.current) return;
    if (
      gridReady &&
      gridRef.current !== undefined &&
      gridRef.current !== null &&
      gridRef.current.columnApi !== null &&
      localStorage.getItem("report-grid") !== null
    ) {
      const raw = localStorage.getItem("report-grid");
      const parsed = raw ? JSON.parse(raw) : [];
      gridRef.current.columnApi.applyColumnState({
        state: parsed,
        applyOrder: true,
      });
      console.log(gridRef.current.api.getFilterModel());
    }
  }, [gridReady, gridRef]);


  const columnChanges = useCallback(
    (event) => {
      if (gridRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `report-grid`,
        JSON.stringify(gridRef.current!.columnApi.getColumnState())
      );
    },
    [gridRef]
  );

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      cellClass: " notarnslate ",
      resizable: true,
      cellClassRules: {
        small: () => fontValue === 1,
        medium: () => fontValue === 2,
        large: () => fontValue === 3,
      },
    }),
    [fontValue]
  );

  useEffect(() => {
    if (gridRef && gridRef.current && gridRef.current?.api !== undefined && gridReady) {
      setSummaryFilterRef(gridRef.current?.api.getFilterModel())
    }
  }, [gridRef, gridReady])

  const durationFormatter = useCallback((params: ValueFormatterParams) => {
    if (
      params.value === undefined ||
      params.value === -Infinity ||
      Number.isNaN(params.value)
    )
      return "--:--";
    const hours = Math.floor(params.value / 3600 / 1000);
    let minutes = Math.floor(
      Math.floor(params.value - hours * 3600 * 1000) / 60 / 1000
    );
    let seconds = Math.floor(
      (params.value - hours * 3600 * 1000 - minutes * 60 * 1000) / 1000
    );
    if (seconds === 60) {
      minutes += 1;
      seconds = 0;
    }
    if (hours > 0) {
      return `${hours.toString()}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }, []);

  const columnDefs: (ColDef | ColGroupDef)[] = useMemo(
    () => [
      {
        headerName: "Platform",
        field: "platform",
        headerClass: "header-center",
        cellClass: "cell-center",
        pinned: "left",
      },
      {
        headerName: "Historical Reporting",
        headerClass: "header-group-center",
        children: [
          {
            headerName: "Inbound",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "callsInbound",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: 'agNumberColumnFilter'
              },
              {
                headerName: "Duration",
                field: "durationInbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "avgDurationInbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "maxDurationInbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
          {
            headerName: "Outbound",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "callsOutbound",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: 'agNumberColumnFilter'
              },
              {
                headerName: "Duration",
                field: "durationOutbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "avgDurationOutbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "maxDurationOutbound",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
          {
            headerName: "Internal",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "callsInternal",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: 'agNumberColumnFilter'
              },
              {
                headerName: "Duration",
                field: "durationInternal",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "avgDurationInternal",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "maxDurationInternal",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
        ],
      },
      {
        headerName: "Platform Traffic Details",
        headerClass: "header-group-center",
        children: [
          {
            headerName: "Direct In",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "directCallsIn",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agNumberColumnFilter",
              },
              {
                headerName: "Duration",
                field: "directDurationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "directAvgDurationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "directMaxDurationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
          {
            headerName: "Direct Out",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "directCallsOut",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: 'agNumberColumnFilter'
              },
              {
                headerName: "Duration",
                field: "directDurationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "directAvgDurationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "directMaxDurationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
          {
            headerName: "Transfer In",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "callsIn",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agNumberColumnFilter",
              },
              {
                headerName: "Duration",
                field: "durationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "avgDurationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "maxDurationIn",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
          {
            headerName: "Transfer Out",
            headerClass: "header-group-center",
            children: [
              {
                headerName: "Calls",
                field: "callsOut",
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: 'agNumberColumnFilter'
              },
              {
                headerName: "Duration",
                field: "durationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Avg Duration",
                field: "avgDurationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
              {
                headerName: "Max Duration",
                field: "maxDurationOut",
                valueFormatter: durationFormatter,
                headerClass: "header-center",
                cellClass: "cell-center",
                filter: "agTextColumnFilter",
                // aggFunc: "mySum",
                filterParams: textFilterParams,
              },
            ],
          },
        ],
      },
    ],
    [durationFormatter]
  );

  useEffect(() => {
    const worker = workerRef.current;
    let lastTs = 0;
    worker.onmessage = (event: MessageEvent) => {
      const { data, startTime } = event.data;
      if (startTime > lastTs) {
        setRowData(data);
        lastTs = startTime;
      } else {
        console.log("Outdated, discarding");
      }
    };
    worker.onerror = (error) => { };
    return () => {
      console.log("Worker killed");
      worker.terminate();
    };
  }, []);

  useEffect(() => {
    if (!organizationId) {
      return;
    }

    workerRef.current.postMessage({
      filterModel,
      dbName: "myDb",
      storeName: `calls-${organizationId}`,
      version,
      roughKey: index,
      startTime: new Date().getTime(),
    });
  }, [filterModel, index, version]);

  return (
    <>
      <div
        style={{
          height: headlinesEnabled ? 253 : 0,
          opacity: headlinesEnabled ? 1 : 0,
          transitionDuration: "0.26s",
          transitionTimingFunction: "cubic-bezier(0,.96,.47,.96)",
        }}
      >
        <HeadlinesReport data={rowData} mode={mode} hasCX={hasCX} />
      </div>
      <AgGridReact
        rowGroupPanelShow="none"
        sideBar={{
          toolPanels: [
            "filters",
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: true,
                suppressColumnSelectAll: true,
                suppressColumnExpandAll: true,
              },
            },
          ],
          defaultToolPanel: "",
        }}
        ref={gridRef}
        // aggFuncs={aggFuncs}
        className="custom-grid"
        columnDefs={columnDefs}
        rowData={rowData}
        rowSelection="single"
        onFilterChanged={() => {
          if (gridRef && gridRef.current && gridRef.current.api !== undefined && gridReady) {
            setSummaryFilterRef(gridRef.current.api.getFilterModel())
          }
        }}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
          params.columnApi.autoSizeAllColumns();
          setGridReady(true);
        }}
        onColumnVisible={columnChanges}
        onSortChanged={columnChanges}
        onColumnMoved={columnChanges}
        onColumnPinned={columnChanges}
        onColumnResized={columnChanges}
        enableCellChangeFlash
        animateRows
        defaultColDef={defaultColDef}
      />
    </>
  );
}
